const nl = {
  translation: {
    //home
    home: "Home",
    vehicles: "Voertuigen",
    sign_in: "Aanmelden",
    plan_you_trip: "Plan nu uw reis",
    save_big: "Bespaar veel met onze betaalbare autoverhuur!",
    with_our_car: "met onze betaalbare autoverhuur!",
    save_big_desc:
      "Huur de auto van uw dromen. Ongelooflijke prijzen, onbeperkte kilometers, flexibele ophaalmogelijkheden en nog veel meer.",
    book_ride: "Rit boeken",
    learn_more: "Meer weten",
    book_a_car: "Een auto boeken",
    without_driver: "Zonder chauffeur",
    with_driver: "Met chauffeur",
    select_booking_type: "Selecteer het type boeking",
    self_drive: "Zelf rijden",
    tour: "Tour / Dagelijkse charter",
    transfer_service: "Transfer Service",
    pickup_date: "Ophaaldatum",
    dropoff_date: "Inleverdatum",
    pickup_location: "Ophaallocatie",
    dropoff_location: "Inleverlocatie",
    book_now: "Nu boeken",
    the_price_exclude: "De prijs is exclusief de chauffeurskosten, die een extra toeslag zullen zijn",
    select_tour_package: "Selecteer Tourpakket",
    select_duration: "Selecteer Duur",
    destination_location: "Bestemmingslocatie",
    quick_and_easy: "Snel en eenvoudig autoverhuur",
    select_car: "Selecteer auto",
    we_offer:
      "Wij bieden een groot scala aan voertuigen voor al uw rijbehoeften. We hebben de perfecte auto om aan uw behoeften te voldoen",
    contact_operator: "Neem contact op met de exploitant",
    our_knowlage:
      "Onze deskundige en vriendelijke operators staan altijd klaar om te helpen bij eventuele vragen of zorgen",
    let_drive: "Laten we rijden",
    whether_you: "Of je nu de open weg op gaat, we hebben je gedekt met ons brede scala aan auto's",
    vehicle_models: "Voertuigmodellen",
    our_rental_fleet: "Onze verhuurvloot",
    choose_from:
      "Kies uit een verscheidenheid aan geweldige voertuigen om te huren voor je volgende avontuur of zakenreis",
    reserve_now: "NU RESERVEREN",
    save_big_bottom: "Bespaar veel met onze goedkope autoverhuur!",
    top_airport: "Topluchthavens. Lokale leveranciers. ",
    support: "ondersteuning",
    why_choose_use: "Waarom voor ons kiezen",
    best_valued: "Beste waarde deals die je ooit zult vinden",
    discover_the_best:
      "Ontdek de beste deals die je ooit zult vinden met onze onverslaanbare aanbiedingen. We zijn toegewijd om u de beste waarde voor uw geld te bieden, zodat u kunt genieten van hoogwaardige diensten en producten zonder de bank te breken. Onze deals zijn ontworpen om u de ultieme huurervaring te bieden, dus mis uw kans niet om veel te besparen.",
    find_details: "Vind details",
    cross_city: "Cross City Drive",
    take_your_driving:
      "Breng uw rijervaring naar een hoger niveau met onze eersteklas voertuigen voor uw cross-country avonturen.",
    all_inclusive: "All-inclusive prijzen",
    get_everything:
      "Krijg alles wat u nodig heeft in één handige, transparante prijs met ons alles-in-één prijsbeleid.",
    no_hidden: "Geen verborgen kosten",
    enjoy_peace:
      "Geniet van gemoedsrust met ons beleid van geen verborgen kosten. Wij geloven in transparante en eerlijke prijzen.",
    review_by_people: "Beoordeeld door mensen",
    client_testimonial: "Getuigenissen van klanten",
    client_testimonial_desc:
      "Ontdek de positieve impact die we hebben gehad op onze klanten door hun getuigenissen te lezen. Onze klanten hebben onze service en resultaten ervaren en ze staan te popelen om hun positieve ervaringen met u te delen.",
    testi_aris:
      "Ik vind het echt leuk. De service is net zo cool als de chauffeur op tijd arriveert en de weg kent. Heel blij, de service is echt cool. De auto ook. Ruikt schoon en alles verloopt soepel. Maak Mas Yoyok (chauffeur) succesvol en gezond, dan ja... Voor een verhuurder van auto's, wil ik niets anders zeggen. Omdat er geen klachten waren. Hoe dan ook, succes.",
    testi_solomon:
      "Ik heb een Avanza gehuurd, type G uit 2016. De auto had geen problemen, de motor liep soepel, de carrosserie was keurig geregistreerd, en het belangrijkste toen je de auto huurde, was het WA-team/groep onmiddellijk voorbereid... voor de gevraagde documenten... dat is cool. het belangrijkste is.",
    faq: "Veelgestelde vragen",
    frequently_asked: "Veelgestelde Vragen",
    frequently_asked_desc:
      "Veelgestelde Vragen Over het Autoverhuurboekingsproces op Onze Website: Antwoorden op Veelvoorkomende Zorgen en Vragen.",
    what_is_special: "1. Wat is er speciaal aan het vergelijken van autoverhuurdeals?",
    what_is_special_desc:
      "Het vergelijken van autoverhuurdeals is belangrijk omdat het helpt de beste deal te vinden die past bij uw budget en eisen, zodat u de meeste waarde krijgt voor uw geld. Door verschillende opties te vergelijken, kunt u deals vinden die lagere prijzen, aanvullende diensten of betere automodellen bieden. U kunt autoverhuurdeals vinden door online onderzoek te doen en prijzen van verschillende verhuurbedrijven te vergelijken.",
    how_do_2: "2. Hoe vind ik de autoverhuurdeals?",
    how_do_2_desc:
      "U kunt autoverhuurdeals vinden door online onderzoek te doen en prijzen van verschillende verhuurbedrijven te vergelijken. Websites zoals Expedia, Kayak en Travelocity stellen u in staat om prijzen te vergelijken en beschikbare huuropties te bekijken. Het wordt ook aanbevolen om u aan te melden voor e-mailnieuwsbrieven en verhuurbedrijven te volgen op sociale media om op de hoogte te worden gebracht van speciale deals of promoties.",
    how_do_3: "3. Hoe vind ik zulke lage prijzen voor autoverhuur?",
    how_do_3_desc:
      "Vroeg boeken: Het van tevoren boeken van uw huurauto kan vaak leiden tot lagere prijzen. Vergelijk prijzen van meerdere bedrijven: Gebruik websites zoals Kayak, Expedia of Travelocity om prijzen van meerdere autoverhuurbedrijven te vergelijken. Zoek naar kortingscodes en coupons: Zoek naar kortingscodes en coupons die u kunt gebruiken om de huurprijs te verlagen. Huren vanaf een locatie buiten de luchthaven kan soms lagere prijzen opleveren.",
    reservation_12: "Reserveringen moeten minstens 12 uur van tevoren worden gemaakt",
    reservation_24: "Reserveringen moeten minstens 24 uur van tevoren worden gemaakt",
    drop_after_pickup: "De inleverdatum moet na de ophaaldatum zijn",
    //car card
    daily_rate_from: "Dagtarief vanaf",
    includes: "Inclusief",
    isurances_etc: "VERZEKERINGEN, KLANTENSERVICE",
    more_info: "Meer Informatie",
    efficient: "Efficiënt",
    safe: "Veilig",
    economical: "Voordelig",
    //select vehicle
    book_car_by_getting: "Boek een auto door contact met ons op te nemen",
    select_vehicle: "Selecteer Voertuig",
    complete_reservation: "VOLTOOI RESERVERING",
    upon_completing: "Na het voltooien van deze reserveringsaanvraag ontvangt u:",
    your_rent_voucher:
      "Uw verhuurvoucher om te tonen bij aankomst bij de verhuurbalie en een gratis klantenservicenummer.",
    location_n_date: "Locatie & Datum",
    car: "Auto",
    pickup_date_n_time: "Ophaaldatum en -tijd",
    dropoff_date_n_time: "Inleverdatum en -tijd",
    prices: "Prijzen",
    additional_items: "Extra Items",
    umbrella: "Paraplu",
    baby_seat: "Kinderstoel",
    insurance: "Verzekering",
    full_covered: "Volledig Gedekte Verzekering",
    wedding: "Bruiloftsauto",
    flower_arrangement: "Bloemstuk (Bruiloftsauto)",
    additional_stop: "Extra Stop",
    flower_bouquet: "Bloemenboeket",
    all_in_one_for: "Tol en parkeren",
    price_estimate: "Prijsraming",
    estimate_total: "Geschat totaal",
    the_price_does_not: "De prijs is exclusief tolheffing, parkeerkosten en fooi",
    the_price_includes: "De prijs is inclusief benzine en eenrichtingsparkeren",
    personal_info: "PERSOONLIJKE INFORMATIE",
    identity_type: "Identiteitstype",
    select_identity: "Selecteer Identiteit",
    identity_image: "Identiteitsafbeelding",
    choose_file: "Kies bestand",
    sim_or: "SIM / Rijbewijs",
    name: "Naam",
    booker_name: "Naam van de boeker",
    enter_booker_name: "Naam van de boeker invoeren",
    enter_name: "Voer uw naam in",
    whatsapp_number: "Whatsapp-nummer",
    enter_whatsapp_number: "Voer uw whatsapp-nummer in",
    email: "E-mail",
    enter_email: "Voer uw e-mailadres in",
    address: "Adres",
    enter_address: "Voer uw adres in",
    emergency_contact_1: "Noodcontact 1",
    emergency_contact_2: "Noodcontact 2",
    enter_emergency: "Voer uw noodcontact in",
    return_flight: "Reservering Terugvlucht",
    hotel_accomodation: "Hotel/Accommodatie Tijdens Uw Verblijf",
    notes: "Notities",
    enter_notes: "Voer uw notities in",
    we_will_ask: "We vragen om aanvullende gegevens indien nodig.",
    rental_policy: "Verhuurbeleid",
    in_town_usage: "Gebruik binnen de stad",
    add_outside_island: "Voeg gebruik buiten het eiland toe",
    outside_island_usage: "Gebruik buiten het eiland",
    for_self_drive: "Gebruik buiten het eiland voor zelfrijden",
    denpasar_jimbaran_etc: "Denpasar, Jimbaran, Legian, Nusa Dua, Uluwatu, Ubud Center, Seminyak.",
    out_of_town_usage: "Gebruik buiten de stad",
    zone_1: "Zone 1",
    zone_2: "Zone 2",
    kerobokan_etc:
      "Bangli, Kintamani, Tabanan, Jatiluwih, Canggu, Pererenan, Gianyar (outside ubud center) (kosten afhankelijk van het type auto)",
    karangasem_etc: "Amed, Singaraja, Pelataran, Menjangan, Jembrana, Tulamben (kosten afhankelijk van het type auto)",
    this_rate_valid: "Dit tarief is geldig voor slechts één richting.",
    add_out_off_town: "Gebruik buiten de stad toevoegen",
    select_date: "Selecteer Datum",
    select_travel_date: "Selecteer een reisdatum buiten de stad",
    select_travel_date_island: "Selecteer een reisdatum buiten het eiland",
    total: "Totaal",
    close: "Sluiten",
    add: "Toevoegen",
    loading: "Laden...",
    //customer form
    additional_information: "Aanvullende Informatie (Optioneel)",
    guest_name: "Naam Gast",
    driver_name: "Naam Bestuurder",
    passanger_total: "Totaal Passagiers",
    luggage_total: "Totaal Bagage",
    flight_detail: "Vluchtdetails",
    airline_name: "voorbeeld: luchtvaartmaatschappij: Garuda, aankomsttijd: 17.00 uur",
    hotel_detail: "Hotel/Accommodatie Details",
    hotel_name: "voorbeeld: hotelnaam: Indah Hotel",
    disability_needs: "Behoeften bij Handicap",
    rolstoel: "voorbeeld: rolstoel: 1",
    the_price_varies: "De prijs varieert afhankelijk van de bestemming.",
    including_petrol: "Inclusief tol, parkeren",
    change: "Wijzigen",
    setting_date_use: "Instellen van de gebruiksdatum",
    date: "Datum",
    //detail vehicle
    detail_vehicle: "Voertuigdetails",
    price_type: "Prijs Type",
    price: "Prijs",
    area: "Gebied",
    yes: "Ja",
    trunk: "Kofferbak",
    customer_service: "KLANTENSERVICE",
    insurances: "VERZEKERINGEN",
    with_a_professional:
      "Met een professionele en uitgebreide after-sales service kunt u gerust zijn van goede ondersteuning van ons team. U kunt ook profiteren van diverse aantrekkelijke aanbiedingen en speciale promoties bij het bestellen van deze auto.",
    select_this_car: "Selecteer deze auto",
    //global
    save: "Opslaan",
    big: "groot",
    days: "Dagen",
    hour: "Uur",
    brand: "Merk",
    year: "Jaar",
    seat: "Zitplaats",
    ac: "Airconditioning",
    color: "Kleur",
    transmission: "Transmissie",
    fuel: "Brandstof",
    company: "Bedrijf",
    working_hour: "Werkuren",
    //privacy and policy
    privacy_and_police: "Algemene Voorwaarden",
    for_overtime:
      "Voor overuren wordt een extra vergoeding van Rp 50.000 per uur in rekening gebracht (Overtijd langer dan 2 uur wordt beschouwd als 1 dag gebruik).",
    for_extension:
      "Voor het verlengen van de huureenheid meer dan 2 keer, verifieer en bevestig alstublieft op ons kantoor, Wirasana Rent A Car Denpasar, Jl. Bypass Ngurah Rai No.162, Sanur Kaja, South Denpasar.",
    unit_vehicles:
      "Verhuureenheid kan niet worden overgedragen/gebruikt door iemand anders dan de huurder die het huurcontract heeft ondertekend (Als de auto als bewijs wordt gebruikt, wordt een dagelijkse huurprijs in rekening gebracht).",
    reschedule_or:
      "Het opnieuw plannen of wijzigen van de locatie van het ophalen/afleveren van de eenheid kan niet worden bevestigd als de kennisgeving minder is dan 1x24 uur volgens het boekingsschema, om operationele instelfouten te voorkomen.",
    reschedule_date:
      "Voor het opnieuw plannen van de datum of tijd van het ophalen/afleveren van de eenheid geldt een vergoeding van Rp 75.000 (maximaal 2 herplanningen toegestaan).",
    for_lose_umbrella:
      "Voor het verlies van een paraplu tijdens de huurperiode wordt een vergoeding van Rp 100.000 per paraplu in rekening gebracht.",
    for_lose_baby_seat:
      "Voor het verlies van een babyautostoeltje tijdens de huurperiode wordt een vergoeding van Rp 2.000.000 per babyautostoeltje in rekening gebracht.",
    usage_unit: "Het gebruik van de eenheid is beperkt tot het gebied Bali.",
    lose_stnk: "Voor het verlies van STNK (voertuigregistratie) geldt een vergoeding van Rp 1.500.000.",
    lose_plat: "Voor het verlies van kentekenplaten geldt een vergoeding van Rp 250.000.",
    for_damage_ban:
      "Voor bandenschade als gevolg van onjuist gebruik/gebruik anders dan asfaltwegen, wordt een vergoeding van Rp 700.000 per band in rekening gebracht.",
    for_beret: "Als er nieuwe krassen zijn, wordt een vergoeding van Rp 750.000 per incident in rekening gebracht.",
    towing_fee: "Sleeptarieven, en huurautotarieven tijdens reparaties zijn niet inbegrepen in de eigen risicokosten.",
    lack_of_petrol:
      "Een tekort aan brandstof tijdens het ophalen of afleveren leidt tot een vergoeding van Rp 100.000 per doos.",
    fuel_in_the_middle:
      "Als u tijdens de reis een brandstoftekort tegenkomt, wordt er een afhandelingsvergoeding van Rp 250.000 in rekening gebracht voor gebieden binnen de stad.",
    smell:
      "Als er een geur van durian/braken/sigaretten/natte autostoelen is bij het terugbrengen van de auto, wordt er een vergoeding van Rp. 1.500.000 in rekening gebracht.",
    dirty_car:
      "Voor een auto die in zeer vuile staat wordt teruggebracht, geldt een schoonmaakvergoeding van Rp. 150.000.",
    lost_the_key: "Voor het verlies van autosleutels wordt een vergoeding van Rp. 1.500.000 in rekening gebracht.",
    more_than_one_driver:
      "Als er meer dan één bestuurder is, wordt er een vergoeding van Rp. 50.000/ID/dag in rekening gebracht.",
    please_not_park:
      "Parkeer het voertuig alstublieft niet onder bomen of op plaatsen die de positie van het voertuig in gevaar kunnen brengen.",
    charging_error: "Bij een brandstofvulfout wordt er een reparatievergoeding van Rp 2.500.000 in rekening gebracht.",
    not_info:
      "Als we geen informatie ontvangen met betrekking tot de behoefte aan assistentie bij voertuigreparatie tijdens de huur, zullen we geen vergoeding accepteren van een werkplaats zonder goedkeuring/discussie.",
    trouble_car:
      "Als er een probleem is met het voertuig, zullen onze monteurs proberen binnen een maximum van 4 uur (afhankelijk van uw locatie op dat moment) te reageren en u te helpen.",
    security_deposit:
      "Een borg van Rp 500.000 wordt bewaard als garantie tijdens de huurperiode (De borg wordt terugbetaald via bankoverschrijving binnen een maximum van 7 dagen na het retourneren van het voertuig en na E-Tilang controle).",
    basic_usage: "Het basisk gebruik is beperkt tot binnen de stad zoals aangegeven op de kaart van Traveloka.",
    excess_usage:
      "Overmatig gebruik na 12 uur of na middernacht leidt tot extra kosten volgens de bijlage/regels van Traveloka.",
    driver_contact: "De chauffeur zal contact met u opnemen wanneer hij bij de ophaallocatie arriveert.",
    other_questions: "Als u andere vragen heeft, neem dan gerust contact met ons op.",
    pickup_point:
      "Het ophaalpunt is voor Solaria. Als u een ander ophaalpunt wilt aanvragen, informeer ons dan direct via deze groep.",
    reschedule_info:
      "Het opnieuw plannen of wijzigen van ophaal- en bestemmingslocaties kan niet worden bevestigd als de kennisgeving minder is dan 24 uur voorafgaand aan de geplande boeking, om operationele instelfouten te voorkomen.",
    reschedule_fee: "Er geldt een vergoeding voor herplanning van IDR 75.000 (maximaal 2 herplanningen).",
    reschedule_airline:
      "Voor herplanningen als gevolg van luchtvaartmaatschappijwijzigingen, voeg alstublieft bewijs van de herplanning toe, en we bevestigen het zonder een herplanningsvergoeding. Het type voertuig voor ophalen is echter afhankelijk van de beschikbaarheid van het voertuig op het herplande tijdstip.",
    airline_delay:
      "In geval van vertraging van de luchtvaartmaatschappij, lever alstublieft bewijs van de vertraging. Onze chauffeur zal er alles aan doen om u op te halen volgens het laatste schema.",
    voucher_usage: "De voucher is geldig voor eenmalig ophalen zonder stops of eenrichtingsreis.",
    additional_stop_meals: "Extra stops voor maaltijden, enz. leiden tot een extra vergoeding van IDR 100.000 per uur.",
    driver_wait_time:
      "De chauffeur wacht tot 30 minuten. Als het de gespecificeerde tijd overschrijdt, wordt er een extra vergoeding van IDR 100.000 per uur in rekening gebracht.",
    destination_change: "Er geldt een extra vergoeding voor wijzigingen van bestemming op basis van de locatie.",
    no_eating_drinking: "Eten en drinken dat morsen in het voertuig kan veroorzaken, is niet toegestaan.",
    boarding_landing: "Bevestig alstublieft zodra u aan boord bent gegaan en geland bent op de luchthaven Ngurah Rai.",
    driver_details: "De details van de chauffeur worden verstrekt op de dag van de reis.",
    mask_and_distance: "Draag altijd een masker en houd sociale afstand in het voertuig.",
    disinfected_vehicles: "Alle voertuigen van Wirasana zijn van tevoren gedesinfecteerd.",
    SWAB_driver_charge: "Extra kosten voor SWAB-chauffeur bedragen IDR 99.000 (indien nodig).",
    passenger: "Passagier",
    use_the_current_location: "Gebruik de huidige locatie",
    cancel: "Annuleren",
    confirm: "Bevestigen",
    i_have_read_and_accept: "Ik heb het privacybeleid gelezen en ga ermee akkoord",
    i_accept_the_privacy: "Ik accepteer het privacybeleid",
    open_filters: "Filters openen",
    sort: "Sorteren",
    price_low_to_high: "Prijs: Laag naar Hoog",
    price_high_to_low: "Prijs: Hoog naar Laag",
    name_a_z: "Naam: A → Z",
    name_z_a: "Naam: Z → A",
    filters: "Filters",
    price_per_day: "Prijs per dag",
    total_passenger: "Totaal aantal passagiers",
    drivetrain: "Aandrijving",
    clear_all: "Alles wissen",
    apply_filters: "Filters toepassen",
    search_car: "Auto zoeken",
    ready_to_continue_payment: "Klaar om door te gaan met betalen?",
    please_review_payment: "Controleer uw betalingsgegevens voordat u doorgaat.",
    total_amount: "Totaal te betalen bedrag",
    proceed_to_payment: "Doorgaan naar betaling",
    about: "Over ons",
    about_company: "Over het bedrijf",
    about_headline: "Start de motor en je avontuur begint",
    about_description:
      "Eenvoudig maar toegewijd, wij bieden de beste service om elke reis comfortabel, veilig en plezierig te maken.",
    about_car_types: "Autotypes",
    about_rental_outlets: "Verhuurpunten",
    about_repair_shop: "Reparatiewerkplaatsen",
    about_book_car: "Boek een auto door contact met ons op te nemen",
    about_phone: "(0361) 286-066",
    language: "Taal",
    about_us: "Over ons",
    contact_us: "Contact",
    booking_type: "Boekingstype",
    the_royal_essence: "De Koninklijke Essentie van de Reis",
    relaxed_journey: "MEEST ONTSPANNEN REIS OOIT",
    page_title: "Contact",
    headline: "Meer informatie nodig?",
    description: "Een veelzijdige professional met meer dan 15 jaar ervaring in onderzoek, ontwikkeling en onderwijs.",
    phone_label: "Telefoon",
    email_label: "E-mail",
    address_label: "Adres",
    form_name: "Volledige naam",
    form_message: "Vertel ons erover",
    form_placeholder_name: "Bijv: 'Jan Jansen'",
    form_placeholder_message: "Schrijf hier...",
    form_button: "Verstuur via WhatsApp",
    required_alert: "Vul alle verplichte velden in!",
    address_value: "Denpasar, Bali",
    why_choose_wirasana: "Waarom Wirasana kiezen",
    trusted_partner: "Uw betrouwbare partner voor autoverhuur op Bali",
    experience_excellence: "Ervaar topkwaliteit met onze premium vloot, uitstekende service en scherpe prijzen.",
    happy_customers: "Tevreden klanten",
    vehicles_available: "Beschikbare voertuigen",
    years_experience: "Jaren ervaring",
    satisfaction_rate: "Tevredenheidspercentage",
    what_makes_us_different: "Wat ons anders maakt",
    discover_advantages: "Ontdek de voordelen die ons onderscheiden van anderen",
    comprehensive_insurance: "Uitgebreide verzekering",
    comprehensive_insurance_desc: "Volledige verzekering inbegrepen bij elke huur. Rijd met een gerust hart.",
    premium_fleet: "Premium vloot",
    premium_fleet_desc: "Moderne, goed onderhouden voertuigen voor de beste rijervaring.",
    support_247: "24/7 Ondersteuning",
    support_247_desc: "Klantenservice die altijd klaarstaat om te helpen.",
    best_price: "Beste prijs garantie",
    best_price_desc: "Transparante prijzen zonder verborgen kosten.",
    flexible_rental: "Flexibele verhuur",
    flexible_rental_desc: "Kies huurperioden van uren tot maanden – wij passen ons aan.",
    free_delivery: "Gratis levering",
    free_delivery_desc: "Gratis levering en ophalen van het voertuig op uw locatie in Bali.",
    more_reasons: "Meer redenen om ons te vertrouwen",
    trusted_by_thousands: "Vertrouwd door duizenden",
    trusted_by_thousands_desc: "Meer dan 10.000 tevreden klanten kozen voor ons op Bali.",
    licensed_insured: "Gelicentieerd & verzekerd",
    licensed_insured_desc: "Volledig gelicentieerde en verzekerde vloot voor uw veiligheid.",
    easy_booking: "Eenvoudig boeken",
    easy_booking_desc: "Online boeken in minuten, zonder papierwerk.",
    flexible_payment: "Flexibele betaalopties",
    flexible_payment_desc: "Creditcards, bankoverschrijvingen en digitale wallets geaccepteerd.",
    cta_title: "Klaar om uw reis te beginnen?",
    cta_desc: "Boek vandaag nog uw perfecte voertuig en ervaar het verschil met Wirasana.",
    call_us_now: "Bel ons nu",
    back: "Rug",
    weather_protection: "Weerbescherming voor buitenactiviteiten",
    safety_seat_children: "Veiligheidszitje voor kinderen (5–4 jaar)",
    beautiful_flower_arrangements: "Prachtige bloemstukken voor speciale gelegenheden",
    extra_stops: "Extra stops tijdens uw reis",
    all_in_one_package: "Alles-in-één pakket voor gemak",
    fresh_flower_bouquet: "Vers bloemenboeketarrangement",
    set_quantity_each_date: "Stel hoeveelheid per datum in",
    total_items: "Totaal items",
    items: "Items",
    select_all: "Alles selecteren",
    select_dates_apply_item: "Selecteer de datums waarop u dit item wilt toepassen",
    item_will_be_applied: "Item wordt toegepast",
    out_of: "van",
    total_day: "totaal dagen",
    type_or_choose_location: "Typ een locatie of kies uit de lijst...",
    select_from_map: "Selecteer locatie van kaart",
    popular_locations: "Populaire locaties",
    manual_input_hint: "Of typ handmatig een locatie in het zoekveld",
    common: {
      back: "Rug",
      back_to_search: "Terug naar Zoeken",
      name: "Naam",
      email: "E-mail",
      phone: "Telefoon",
      total: "Totaal",
      hours: "Uur",
      processing: "Verwerken...",
      searching: "Zoeken...",
      error_occurred: "Er is een fout opgetreden. ",
      information: "Informatie",
    },
    booking: {
      detail: "Boekingsgegevens",
      booking_number: "Boeking #{{number}}",
      not_found: "Gegevens niet gevonden",
      search_again: "Zoek uw boeking opnieuw",
      type: "Boekingstype",
      pickup_date: "Ophaaldatum",
      dropoff_date: "Afleverdatum",
      price_breakdown: "Prijsverdeling",
      price_date: "Prijs ({{date}})",
      fees: "Transactiekosten en belastingen",
      delivery_fee: "Bezorgkosten",
      pickup_fee: "Ophaalkosten",
      canceled: "Bestelling geannuleerd",
      contact_customer_service: "Deze bestelling is geannuleerd. ",
      check_history: "Controleer de boekingsgeschiedenis",
      enter_details: "Voer uw e-mailadres en boekingscode in om uw bestelgegevens te bekijken",
      booking_code: "Boekingscode",
      code_example: "Voorbeeld: S-0018, T-0025 (gebruik S-0018 voor demo)",
      check_booking: "CONTROLEER BOEKING",
      info_code_sent: "De boekingscode wordt na het boeken naar uw e-mail verzonden",
      info_continue_payment: "U kunt de betaling voor onbetaalde bestellingen voortzetten",
      info_contact_support: "Neem contact op met de klantenservice als u problemen ondervindt",
    },
    status: {
      booked: "Geboekt",
      prepared: "Voorbereid",
      operated: "Geëxploiteerd",
      canceled: "Geannuleerd",
      success: "Succes",
    },
    payment: {
      not_paid: "Niet betaald",
      paid: "Betaald",
      partial: "Gedeeltelijke betaling",
      continue: "VERDER BETALEN",
      invoice_not_found: "Factuur niet gevonden",
      link_failed: "Kan betalingslink niet aanmaken. ",
      received: "Betaling ontvangen",
      total_paid: "Totaal betaald: {{amount}}",
    },
    validation: {
      fill_all_fields: "Vul uw e-mailadres en boekingscode in",
    },
    manage_booking: "Boeking beheren",
    booking_confirmation: "Boekingsbevestiging",
    next: "Volgende",
    booking_details: "Boekingsgegevens",
    review_n_confirm: "Beoordelen en bevestigen",
    booking_success: "Boeking succesvol!",
    booking_success_message: "Uw boeking is succesvol verzonden. ",
    open_payment_link: "Betaallink openen",
    required_documents: "Vereiste documenten",
    payment_information: "Betalingsinformatie",
    review_payment_details: "Controleer uw betalingsgegevens en ga verder met betalen",
    booking_summary: "Boekingsoverzicht",
    invoice_number: "Factuurnummer",
    customer_name: "Klantnaam",
    payment_instructions: "Betalingsinstructies",
    payment_instruction_1: "Klik op onderstaande knop om een ​​betalingsfactuur aan te maken",
    payment_instruction_2: "U wordt doorgestuurd naar de Xendit-betaalpagina",
    payment_instruction_3: "Voltooi uw betaling met behulp van de beschikbare betaalmethoden",
    payment_instruction_4: "U ontvangt een bevestigingsmail na succesvolle betaling",
    payment_link_created: "Betaallink is aangemaakt!",
    click_below_to_proceed: "Klik op onderstaande knop om door te gaan naar de betaling",
    creating_invoice: "Factuur aanmaken...",
    create_payment_invoice: "Betalingsfactuur maken",
    done: "Ik heb de betaling voltooid",
    order_summary: "Bestellingsoverzicht",
    please_review_order: "Controleer uw bestelgegevens voordat u doorgaat met betalen",
    customer_information: "Klantinformatie",
    phone: "Telefoon",
    vehicle: "Voertuig",
    rental_period: "Huurperiode",
    locations: "Locaties",
    price_breakdown: "Prijsopbouw",
    base_price: "Basisprijs",
    delivery_fee: "Bezorgkosten",
    pickup_fee: "Afhaalkosten",
    tour_package: "Tourpakketprijzen vanaf",
    airport_transfer_from: "Prijzen voor luchthaventransfers vanaf",
    tourPackage: "Rondreis Pakket",
    basic_title: "Basisbescherming",
    basic_subtitle: "Basisdekking inbegrepen in uw huur",
    km_unlimited: "Onbeperkte kilometers",
    own_risk: "Met een eigen risicovergoeding van Rp 750.000 per incident",
    damage_cover: "Dekking voor aanrijding, krassen en stootschade",
    glass_tire: "Bescherming van banden en glas",
    interior_protect: "Bescherming van binnenuit",
    not_included_towing: "Omvat geen sleepservice en extra huurdagen als de reparatie langer dan 7 dagen duurt",
    got_it: "Ik heb het",
    basic_protection: "Basisbescherming",
    see_more_details: "Zie meer details",
    gps: "GPS",
    gps_desc: "Navigatiesysteem in de auto.",
    phone_holder: "Telefoonhouder",
    phone_holder_desc: "Handsfree houder voor veilig rijden.",
    family_card: "Gezinskaart",
    business_id: "Bedrijfs-ID",
    social_media: "Sociale Media",
    customer_info: "Klantinformatie",
    enter_social_media: "Sociale media invoeren",
    insurance_subtitle: "Bescherm uw reis met uitgebreide dekking en gemoedsrust",
    included: "Inbegrepen",
    not_included: "Niet inbegrepen",
    toll_and_parking: "Tol en Parkeren",
    toll_and_parking_desc: "Tol- en parkeerkosten",
    your_trusted_mobility: "Uw vertrouwde mobiliteitspartner op Bali",
    wirasana_is_professional:
      "Wirasana Rent A Car is een professionele autoverhuurservice gevestigd op Bali, toegewijd aan het bieden van betrouwbare, comfortabele en flexibele transportoplossingen voor reizigers en bedrijven. Met jarenlange ervaring in de transportindustrie begrijpen we dat mobiliteit een essentieel onderdeel is van elke reis — of het nu gaat om vrije tijd, zaken of speciale gelegenheden.",
    our_mission_is_to_make:
      "Onze missie is om transport op Bali eenvoudig, veilig en toegankelijk te maken. We bieden een breed scala aan goed onderhouden voertuigen die aan verschillende behoeften voldoen, van compacte auto's voor persoonlijke ritten tot premium voertuigen voor zaken en speciale evenementen.",
    lets_get_you: "Laten we u op weg helpen",
    have_questions_about:
      "Heeft u vragen over onze voertuigen, prijzen of beschikbaarheid? Ons team staat klaar om u te helpen. Of u nu een vakantie op Bali plant, een zakenreis of een speciaal evenement, wij zijn er om uw transportervaring soepel en zorgeloos te maken.",
    search_vehicle: "Voertuig zoeken",
    vehicle_type: "Voertuigtype",
    motorcycle: "Motorfiets",
    all: "Alle",
    your_trustedcar_rental_in_bali: "Uw betrouwbare autoverhuur op Bali",
    simple_booking: "Eenvoudig boeken. Betrouwbare voertuigen. Uitzonderlijke service.",
    we_provide_flexible:
      "Wij bieden flexibele huuroplossingen, waaronder zelf rijden, chauffeursservice en luchthaventransfers, allemaal ontworpen om uw reis op Bali moeiteloos te maken.",
  },
};
export default nl;
